
 <ng-container
	*rxFor="let media of media$" 
>	
	<lib-media
		class="slide"
		[src]="media.src"
		[srcset]="media.srcset"
		[sizes]="media.sizes"
		[type]="media.type"
		[alt]="media.alt"
		loading="eager"
		[@fadeAnimation] 
	>	
	</lib-media>

</ng-container>

